import { SKIN_STORAGE_KEY } from "../hooks/skin";

const store = window.localStorage;
export const AUTH_TOKEN_KEY = "auth-token";
export const REFRESH_TOKEN_KEY = "refresh-token";
export const KEEP_SIGNED_IN_KEY = "keep-signed-in";
export const AUTH_LOCKED_KEY = "auth-storage-locked";

export function getItem(key) {
  return store.getItem(key);
}

export function setItem(key, value) {
  store.setItem(key, value);
}

export function removeItem(key) {
  store.removeItem(key);
}

// This browser's display choices, not the account's: they outlive a logout
const PREFERENCE_KEYS = [SKIN_STORAGE_KEY, "menuCollapsed"];

export function clearKeepingPreferences() {
  const kept = PREFERENCE_KEYS.map((key) => [key, store.getItem(key)]);
  store.clear();
  kept.forEach(([key, value]) => {
    if (value !== null) store.setItem(key, value);
  });
}
